import {LocalStorage} from '@wix/wix-events-commons-statics'

const CURRENT_ROUTE_LOCAL_STORAGE_KEY = 'currentPageRoute'

export const getCurrentRoute = () => LocalStorage.getItem(CURRENT_ROUTE_LOCAL_STORAGE_KEY)

export const setCurrentRoute = (route: string) => LocalStorage.setItem(CURRENT_ROUTE_LOCAL_STORAGE_KEY, route)

export const monitorCurrentRoute = async cb => LocalStorage.monitorItem(CURRENT_ROUTE_LOCAL_STORAGE_KEY, cb)
